import AccettazioneSsnEditViewPage from "./pages/AccettazioneSsnEditViewPageOld.vue";
import AccettazioneSsnListPage from "./pages/AccettazioneSsnListaPageOld.vue";
import AccettazioneSsnSchedaPazientePage from "./pages/AccettazioneSsnSchedaPazientePage.vue"


import AccettazionePrenotazioniLazioListPage from "./pages/AccettazionePrenotazioniLazioListPage.vue";
import AccettazioneSsnEditViewPageN from "./pages/AccettazioneSsnEditViewPage.vue";
import AccettazioneSsnListPageN from "./pages/AccettazioneSsnListaPage.vue";
export default {
    AccettazioneSsnListPage,
    AccettazioneSsnEditViewPage,
    AccettazioneSsnSchedaPazientePage,
    AccettazioneSsnEditViewPageN,
    AccettazioneSsnListPageN,
    AccettazionePrenotazioniLazioListPage
};
